import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProviderMediaComponent } from './provider-media.component';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [ProviderMediaComponent],
  imports: [CommonModule, SplitButtonModule, ButtonModule, TooltipModule],
  exports: [ProviderMediaComponent],
})
export class ProviderMediaModule {}
